import React, { useCallback } from 'react';
import { Col, Row, Card } from 'reactstrap';
import { StatusSelect } from '..';
import { ViewConfig } from '../../viewConfig.types';
import { IValidatedComponentProps, IBaseFieldProps, useFormContext } from 'react-ocean-forms';
import { ViewMode } from '../../Common/ViewMode';
import { useRole } from '../../../hooks';
import { IStatusUtil } from '../../../api';

interface BaseStatusFormProps  {
  statusUtil: IStatusUtil;
  disabled?: boolean;
  viewConfig: ViewConfig;
  right?: boolean;
}

type StatusFormProps = BaseStatusFormProps & IBaseFieldProps & IValidatedComponentProps;

/**
 * @author Jungwirth
 */
export const StatusForm: React.FC<StatusFormProps> = (props: Readonly<StatusFormProps>): JSX.Element => {
  const { name, label, statusUtil, viewConfig, disabled, right } = props;
  
  const role = useRole();
  const { defaultValues } = useFormContext();

  const getStatusList = useCallback(async () => {
    // @ts-ignore
    const result = statusUtil.getStatusList(role, viewConfig.viewName, defaultValues.status);
    return result;

  },[role, viewConfig.viewName, statusUtil, defaultValues]);

  return (
    <Card body className="border-0">
      <Row>
        {right &&
          <Col md={6}>
          </Col>
        }
        <Col md={6}>
          <StatusSelect
            name={name}
            label={label}
            multi={viewConfig.viewName === ViewMode.Search}
            selectAll={viewConfig.viewName === ViewMode.Search}
            {...viewConfig.fields.status.field}
            disabled={disabled || viewConfig.fields.status.field.disabled}
            getList={getStatusList} />
        </Col>
      </Row>
    </Card>
  );

};
